import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import * as serviceWorker from './serviceWorker';
import App from './App';
import configureStore from './config/configureStore';
import { RootState } from './store';

import './assets/styles/variables.css';
import './assets/styles/antdOverrides.less';
import './index.less';

import traceitClient from './library/traceit-init';
import axios, { AxiosResponse } from 'axios';
// import { refreshInternalData } from './store/actions/utilAction';
import ApplicationDetail from './shared/services/applicationDetail.service';
// import {registerServiceWorker} from './serviceWorker';
import {decryptText} from './utils/encryptDecrypt';
import TagManager from 'react-gtm-module';

const Traceit = traceitClient.getPlugin('react');
const tagManagerArgs = {
  gtmId: 'GTM-WPPVXVW',
  userId: decryptText(window?.localStorage?.userDetail?.userId),
};
TagManager.initialize(tagManagerArgs);

const beforeSend = (report: any): void => {
  // add user data in the error log report
  const userDetails = decryptText(window?.localStorage?.userDetail);
  report.user = userDetails ? { ...report.user, ...JSON.parse(userDetails) } : report.user;
};

export const store = configureStore({} as RootState);
// const { dispatch } = store;

axios.interceptors.response.use((response: AxiosResponse): AxiosResponse => {
  const { data, headers } = response;
  const appService = ApplicationDetail.instance;
  const masterDataCurrVersion = localStorage.getItem('x-md-cv');
  if (
    appService.getIsMasterDataUpdateAllowed() &&
    headers['x-md-cv'] &&
    data?.isSuccess &&
    String(headers['x-md-cv']) !== masterDataCurrVersion
  ) {
    // dispatch(refreshInternalData(true, true, true, headers['x-md-cv'])); // commented because it is calling the login api with the help
   // of refresh token,it was implemented to store the master the localStorage and to modify it when they send 'x-md-cv'in header response
  }
  if (headers['x-md-cv'] && data?.isSuccess) {
    data.masterDataVersion = headers['x-md-cv'];
  }
  return data;
});

ReactDOM.render(
  // <React.StrictMode>
  <Provider store={store}>
    <BrowserRouter>
    <Traceit beforeSend={beforeSend}>
      <App />
    </Traceit>
    </BrowserRouter>
  </Provider>
,
  // </React.StrictMode>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.register({
//   onUpdate: (registration: ServiceWorkerRegistration): any => {
//     const waitingServiceWorker = registration.waiting;
//
//     if (waitingServiceWorker) {
//       waitingServiceWorker.addEventListener('statechange', (event: any): any => {
//         if (event.target.state === 'activated') {
//           window.location.reload();
//         }
//       });
//       waitingServiceWorker.postMessage({ type: 'SKIP_WAITING' });
//     }
//   },
// });
//
// registerServiceWorker();

serviceWorker.unregister();
